import React from 'react'

function Download() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.314" height="19.033" viewBox="0 0 16.314 19.033">
      <g id="download" transform="translate(-4.5 -2.25)">
        <path id="Path_3243" data-name="Path 3243" d="M20.345,11.087l-.958-.958L14.227,15.28V2.25H12.868V15.28L7.708,10.128l-.958.958,6.8,6.8Z" transform="translate(-0.891)" fill="#f37320" />
        <path id="Path_3244" data-name="Path 3244" d="M19.454,27v2.719H5.859V27H4.5v2.719a1.359,1.359,0,0,0,1.359,1.359H19.454a1.359,1.359,0,0,0,1.359-1.359V27Z" transform="translate(0 -9.796)" fill="#f37320" />
      </g>
    </svg>
  )
}

export default Download